<template>
  <!-- 实名认证 合伙人 -->
  <div class="">
    <template v-if="partnerType === 1">
      <p class="real-name-title">公司营业执照</p>
      <div class="row-space">
        <div class="resume-box">
          <template v-if="resume">
            <img :src="resume.fileUrl" @click="viewBigImage(resume.fileUrl)" class="single-uploader-image">
          </template>
          <img src="" class="single-uploader-image" v-else>
        </div>
      </div>
    </template>
    <template v-else-if="partnerType === 2">
      <p class="real-name-title">个人身份证</p>
      <div class="identity-card-row row-space">
        <div class="identity-card-box">
          <template v-if="identityCardFront">
            <img :src="identityCardFront.fileUrl" @click="viewBigImage(identityCardFront.fileUrl)" class="single-uploader-image">
          </template>
          <img src="" class="single-uploader-image" v-else>
        </div>
        <div class="identity-card-box">
          <template v-if="identityCardBack">
            <img :src="identityCardBack.fileUrl" @click="viewBigImage(identityCardBack.fileUrl)" class="single-uploader-image">
          </template>
          <img src="" class="single-uploader-image" v-else>
        </div>
      </div>

      <p class="real-name-title">从业简历认证</p>
      <div class="row-space">
        <template v-if="resume">
          <el-link :underline="false" @click="clickDownUrlFile(resume.fileUrl)">{{ getUrlFileName(resume.fileUrl) }}</el-link>
        </template>
        <template v-else>
        </template>
      </div>
    </template>

    <el-dialog
      :visible.sync="visibleViewImage"
      :close-on-press-escape="false"
      :close-on-click-modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      @closed="viewImageUrl = ''"
    >
      <img width="100%" :src="viewImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import {
  downLoadFileUrl,
  getUrlAfterUploadFile,
  getUrlAfterUploadImg, getUrlFileName,
  uploadImageBefore
} from "@/assets/js/utils.upload";
import {isArray, isObject} from "my-tools-kit";

export default {
  name: "viewRealNameAuthenticationPartnerInfo",
  props:{
    // 类型 1：销售代理认证 2：分销大使认证，3：省代 4：产业带加盟商 5：专线/分段供应商入驻  6:城市合伙人
    type:{
      type:[Number,String],
      default:6,
    },
    // 合伙人认证类型 1:公司 2:个人
    partnerType:{
      type:[Number,String],
      default:2,
    },
    // 实名认证上传文件列表
    fileList:{
      type:Array,
      default:()=>[]
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      ossPath,
      // 查看图片大图
      visibleViewImage:false,
      viewImageUrl:"",
    }
  },
  computed:{
    // 身份证（正面）
    identityCardFront(){
      return this.findFileList(this.fileList,1);
    },
    // 身份证（背面）
    identityCardBack(){
      return this.findFileList(this.fileList,2);
    },
    // 从业简历
    resume(){
      return this.findFileList(this.fileList,3);
    }
  },
  methods:{
    getUrlFileName,
    /**
     * 从已上传文件列表中筛选匹配类型的文件
     * @param list  {Array<Object>}
     * @param type  {number} 1:身份证（正面） 2:身份证（反面）3:从业简历/公司营业执照
     */
    findFileList(list,type){
      if(isArray(list) && typeof type === "number"){
        let target = list.find(item=>{
          if(isObject(item)) return item.attachmentType === type;
          return false;
        })
        return !!target ? target : null;
      }
      return null
    },
    /**
     * 点击下载文件
     * @param url
     */
    clickDownUrlFile(url){
      if(url) downLoadFileUrl(url)
    },
    /**
     * 查看大图
     */
    viewBigImage(url=""){
      this.viewImageUrl = url;
      this.visibleViewImage = true;
    },
  },
}
</script>

<style scoped lang="scss">
.real-name-title{
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
}

.identity-card-row{
  display: flex;
}
.row-space{
  margin-bottom: 40px;
}
.identity-card-box{
  width: 194px;
  height: 168px;
}
.single-uploader-image{
  width: 100%;
  height: 100%;
  display: block;
  border: none;
  object-fit: contain;
}
.resume-box{
  width: 176px;
  height: 227px;
}
.upload-inner-box{
  width: 100%;
  height: 100%;
  position: relative;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.tools-row{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  opacity: 0;
  background-color: rgba(0,0,0,.5);
  transition: opacity .3s;
  text-align: center;
  color: #fff;
  cursor: default;
  &:hover{
    opacity: 1;
  }
  .tools-item{
    cursor: pointer;
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/realNameAuthentication/viewRealNameAuthenticationPartnerInfo.vue